import React, { PropsWithChildren, useState } from "react";
import "./InfoCard.css";
import { useIsMobile } from "src/hooks/useIsMobile";

interface InfoCardProps extends PropsWithChildren {
  image?: string;
  title: string;
  imageTitle?: string;
  zeroPadding?: boolean;
}
const InfoCard: React.FC<InfoCardProps> = ({
  image,
  title,
  imageTitle,
  zeroPadding,
  children,
}) => {
  const [imageHasError, setImageHasError] = useState(false);
  const { isMobile } = useIsMobile();
  const imageExists = !imageHasError && image;

  const handleImageError = () => {
    setImageHasError(true);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <div className="info-container">
        {imageExists && (
          <div className="info-image-section">
            <img
              src={image}
              alt={title}
              className="info-image"
              onError={handleImageError}
            />
            <h3 className="info-image-title">{imageTitle ?? title}</h3>
          </div>
        )}

        <div className={`info-card ${zeroPadding ? "zero-padding" : ""}`}>
          {(!isMobile || !imageExists) && (
            <div className="info-card-title-container">
              <h2>{title}</h2>
            </div>
          )}
          <div className="info-card-content-container">
            {!isMobile && (
              <div className="info-card-decoration">
                <div className="info-card-circle" />
                <div className="info-card-line" />
              </div>
            )}

            <div
              className={`info-content ${zeroPadding ? "zero-padding" : ""}`}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
